module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67 67"><path class="st0" d="M33.5 0C15 0 0 15 0 33.5S15 67 33.5 67 67 52 67 33.5 52 0 33.5 0M42 21.6h-3.2c-2.3 0-2.5.9-2.5 2.5v3.1H42l-.7 6.3h-5v18.2h-7.5V33.6H25v-6.3h3.8v-3.8c0-5.2 2.2-8.2 8.2-8.2h5v6.3z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fb.svg
// module id = 116
// module chunks = 1